export enum ToggleSize {
  SMALL = 'small',
  MEDIUM = 'medium',
}

export interface ToggleProps {
  title?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  checked?: boolean;
  name: string;
  className?: string;
  size?: ToggleSize;
  tabIndex?: number;
  visualClassName?: string;
}

export interface CheckboxProps {
  type: 'checkbox' | 'radio';
  title: string | React.ReactNode;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  value?: string;
  checked?: boolean;
  name: string;
  labelClassName?: string;
  visualClassName?: string;
  tabIndex?: number;
  partialChecked?: boolean;
  description?: string;
  partialDisabled?: boolean;
}

export interface CheckboxFilterTypes {
  fields?: {
    name?: string | undefined;
    title: string;
    value?: string | undefined;
  }[];
  values?: {
    value: string[];
  };
  onChange?: (data: string[]) => void;
  name: string;
  withClearButton?: boolean;
  type: 'checkbox' | 'radio';
}
